import styled from "styled-components";

type UnreadIndicatorType = {
    color: string;
}

export const UnreadIndicator = styled.span<UnreadIndicatorType>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${props => props.color};
    margin-left: 4px;
    display: inline-block;
`;

export const ContainerUnreadIndicator = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
`;

export const ContentUnreadIndicator = styled.div`
    display: flex;
    height: 22px;
    min-height: 22px;
    max-height: 22px;
    align-items: center;
    justify-content: center;
`;